<template>
  <q-layout view="Hhh lpr fff">
    <q-layout-header>
      <q-toolbar>
        <q-btn
          flat
          dense
          @click="back"
          icon="chevron_left"
          :label="$t('nav.activities')"
        />
        <q-btn
          flat
          dense
          @click="back"
          class="q-ml-auto"
          :label="$t('activity_detail.done')"
        />
      </q-toolbar>
    </q-layout-header>
    <q-page-container>
      <q-page padding>
        <q-field v-for="(f, fldName) in fields"
          :key="fldName"
          :label="f.label"
          class="q-mb-md"
        >
          <q-input
            v-if="f.type === 'string' &&
              ['date', 'time', 'datetime'].indexOf(f.dataType) === -1"
            type="text"
            v-model="activity.attributes[fldName]"
            :disable="f.readOnly"
          />
          <q-input
            v-if="f.type === 'textarea'"
            type="textarea"
            v-model="activity.attributes[fldName]"
            :disable="f.readOnly"
          />
          <picklist
            v-if="f.type === 'picklist' || f.type === 'picklist.multiple'"
            v-model="activity.attributes[fldName]"
            :picklistId="f.picklist_id"
            :multiple="f.type === 'picklist.multiple'"
            :disable="f.readOnly"
          />
          <q-datetime
            v-if="['date', 'time', 'datetime'].indexOf(f.dataType) !== -1"
            :type="f.dataType"
            v-model="activity.attributes[fldName]"
            auto-close
            :format="dateFormat(f.dataType)"
            :disable="f.readOnly"
          />
          <q-checkbox
            v-if="f.type === 'boolean'"
            v-model="activity.attributes[fldName]"
            :disable="f.readOnly"
          />
        </q-field>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import crmService from '@/services/crm_service'
import picklist from '@/components/Picklist'
import config from 'config'

export default {
  components: { picklist },
  data () {
    return {
      message: null,
      allowedFieldTypes: [
        'string',
        'textarea',
        'picklist',
        'picklist.multiple',
        'date',
        'time',
        'datetime',
        'boolean',
        'integer'
      ]
    }
  },
  computed: {
    activity () {
      return this.$store.getters.activity(this.$route.params.id)
    },
    schema () {
      return this.$store.state.schema.schema.activities.attributes
    },
    fields () {
      const result = {}
      config.activities.fields.forEach(fldName => {
        const fld = this.schema[fldName]
        if (fld && this.allowedFieldTypes.includes(fld.type)) result[fldName] = fld
      })
      return result
    }
  },
  methods: {
    back () {
      const saveObj = Object.assign({}, this.activity)
      Object.keys(saveObj.attributes).forEach(key => {
        if (!Object.keys(this.fields).includes(key)) delete saveObj.attributes[key]
      })
      delete saveObj.relationships
      crmService.updateActivity(saveObj, (success, msg) => {
        if (!success) {
          this.$q.notify({
            message: this.$t('general.save_failed'),
            position: 'top'
          })
        }
        this.$router.back()
      })
    },
    dateFormat (dataType) {
      switch (dataType) {
        case 'date':
          return 'DD.MM.YYYY'
        case 'time':
          return 'HH:MM'
        case 'datetime':
          return 'DD.MM.YYYY HH:MM'
        default:
          return 'DD.MM.YYYY HH:MM'
      }
    }
  },
  mounted () {
    this.$store.dispatch('getActivity', this.$route.params.id)
    this.$store.dispatch('getSchema', { mod: 'activities', locale: this.$i18n.locale })
  },
  meta () {
    // Quasar meta plugin sets document title
    return {
      title: this.$t('nav.activities')
    }
  }
}
</script>
